import type { DocumentSnapshot } from '@creator/sdk/modules/db/db.model';
import type { ModActivity } from '@creator/sdk/modules/mod-activity/mod-activity.model';
import type { GetModActivityFilterBy, GetModActivityOrderBy } from '@creator/sdk/modules/mod-activity/mod-activity.service';
import type { Pagination } from '@creator/sdk/utils/utils';
import creatorSdk from '@src/services/creator-sdk';

export async function loadModActivity(
    tokenName: string,
    startAfter: DocumentSnapshot | null,
    limit: number,
    filterBy?: GetModActivityFilterBy[],
    orderBy?: GetModActivityOrderBy
): Promise<Pagination<ModActivity>> {
    return creatorSdk.modActivityModule.getModActivity(tokenName, startAfter, limit, filterBy, orderBy);
}
